import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import {provideCharts,withDefaultRegisterables,} from 'ng2-charts';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes), provideClientHydration(), provideAnimationsAsync(),provideCharts(withDefaultRegisterables())]
};



